import { OPT_IN_CONTENT_BLOCKER_ALL, isCurrentlyInTransaction } from "../..";
import { MEMORIZE_NATIVE_EVENT_PROPERTY, dispatchInitiatorExecution } from ".";
const OVERWRITE_PROPERTY = "rcbNativeEventListener";

/**
 * Overwrite `window.addEventListener('load')` as they can not be triggered by our script blocker.
 * This can also be used for other known events.
 */
function applyNativeEventListenerInitiator(element, eventName) {
  let {
    onBeforeExecute
  } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    onBeforeExecute: undefined
  };
  const overwriteProp = `${OVERWRITE_PROPERTY}_${eventName}`;
  const memorizeProp = `${MEMORIZE_NATIVE_EVENT_PROPERTY}_${eventName}`;

  // Only overwrite once
  if (element[overwriteProp]) {
    return;
  }
  const {
    addEventListener
  } = element;
  Object.assign(element, {
    [overwriteProp]: true,
    addEventListener: function (type) {
      for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        rest[_key - 1] = arguments[_key];
      }
      if (type === eventName) {
        // Redirect to own thread to avoid variable order lacks (e. g. Uncode Gmaps Integration, Contact Form 7
        const executeHandle = () => setTimeout(() => {
          const afterExecution = dispatchInitiatorExecution({
            type: "nativeEvent",
            eventName
          });
          onBeforeExecute?.();
          rest[0]?.(new Event(eventName, {
            bubbles: true,
            cancelable: true
          }));
          afterExecution();
        }, 0);
        if (isCurrentlyInTransaction()) {
          const memorizeExecutionPromise = element[memorizeProp];
          let executed = false;
          document.addEventListener(OPT_IN_CONTENT_BLOCKER_ALL, () => {
            // IE does not support the `once` option
            if (executed) {
              return;
            }
            executed = true;
            if (memorizeExecutionPromise) {
              memorizeExecutionPromise.then(executeHandle);
            } else {
              executeHandle();
            }
          });
        } else {
          executeHandle();
        }
      } else {
        addEventListener.apply(this, [type, ...rest]);
      }
    }
  });
}
export { applyNativeEventListenerInitiator };